import { render, staticRenderFns } from "./VFormInputTextarea.vue?vue&type=template&id=611abf2a&scoped=true&"
import script from "./VFormInputTextarea.vue?vue&type=script&lang=js&"
export * from "./VFormInputTextarea.vue?vue&type=script&lang=js&"
import style0 from "./VFormInputTextarea.vue?vue&type=style&index=0&id=611abf2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611abf2a",
  null
  
)

export default component.exports